import React, { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  doc, 
  getDoc,
  addDoc,
  updateDoc,
  Firestore 
} from 'firebase/firestore';
import { getFunctions, httpsCallable, Functions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { useAuth } from '../../hooks/AuthProvider';
import UserIcon from '../authentication/UserIcon';
import AppManager from '../AppManager/AppManager'; // Import the new AppManager component
import app from '../../Firebase';
import '../../styles/AdminPanel.css';
import LoadingPage from '../LoadingPage';

/**
 * Admin Panel - Requires APP_ADMIN permission
 * 
 * Permissions allowed in this component:
 * - APP_ADMIN: Can view all content and access all features
 * 
 * Future permissions to consider:
 * - CONFERENCE_ADMIN: Could be limited to only managing conferences
 * - USER_ADMIN: Could be limited to only managing users
 * - CONTENT_ADMIN: Could be limited to only managing content
 * - APP_MANAGER: Could be limited to only managing apps
 */

const AdminPanel: React.FC<{ db: Firestore }> = ({ db }) => {
  const { currentUser } = useAuth();
  const [activeSection, setActiveSection] = useState<string | null>('apps');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  // const functions = getFunctions(app);
  const functions = getFunctions(app, "europe-west2");
  const storage = getStorage();
  
  // Clear success and error messages when changing sections
  useEffect(() => {
    setError('');
    setSuccess('');
  }, [activeSection]);

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };

  // Helper to automatically dismiss success messages after 5 seconds
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess('');
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <div className="admin-panel">
      <header className="admin-header">
        <div className="header-title" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "20px" }}>
        <span className="text-2xl font-bold text-black" style={{fontWeight: "bold", color: "white", fontSize: "x-large"}}>Dine<span className="text-blue-600"  style={{fontWeight: "bold", color: "royalblue", fontSize: "x-large"}}>Platform</span></span>
        </div>
        <div className="header-user">
          <UserIcon />
        </div>
      </header>

      {error && (
        <div className="error-alert">
          <button className="close-alert" onClick={() => setError('')}>×</button>
          {error}
        </div>
      )}

      {success && (
        <div className="success-alert">
          <button className="close-alert" onClick={() => setSuccess('')}>×</button>
          {success}
        </div>
      )}

      <div className="admin-content">
        {/* <div className="admin-sidebar">
          <h2>Administration</h2>
          <nav className="admin-nav">
            <button 
              className={`admin-nav-item ${activeSection === 'apps' ? 'active' : ''}`}
              onClick={() => handleSectionChange('apps')}
            >
              Manage Apps
            </button>

          </nav>
        </div> */}

        <div className="admin-main-content">
          {!activeSection && (
            <div className="empty-section">
              <h2>Welcome to Admin Panel</h2>
              <p>Select a section from the sidebar to get started.</p>
            </div>
          )}

          
          {activeSection === 'apps' && (
            <AppManager
              db={db}
              functions={functions}
              storage={storage} 
              onError={setError}
              onSuccess={setSuccess}
              setLoading={setLoading}
            />
          )}

          {activeSection === 'users' && (
            <div className="section-placeholder">
              <h2>User Management</h2>
              <p>This section is not yet implemented.</p>
            </div>
          )}
        </div>
      </div>

      {loading && (
        <LoadingPage />
      )}
    </div>
  );
};

export default AdminPanel;